fx.ns("shared.renderers", class StickerRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);
	}

	render()
	{
        //return '<img class="draggable" data-class="Sticker" src="' + this.data.thumb + '" data-id="' + this.data.id + '" data-width="' + this.data.width + '" data-height="' + this.data.height + '" >';
        return '<img class="draggable" data-class="Sticker" src="' + this.data.thumb + '" data-id="' + this.data.id + '" data-width="' + this.data.width + '" data-height="' + this.data.height + '" >';
	}

	
});